/**
 * Create Credential Dialog
 *
 * A wrapper around the new CredentialDialog for backward compatibility.
 * Used for inline credential creation from node properties.
 */

import { CredentialDialog } from '@/components/credentials';

interface CreateCredentialDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: (credentialId: string) => void;
  /** Filter to only show specific credential types */
  allowedTypes?: string[];
}

export function CreateCredentialDialog({
  open,
  onOpenChange,
  onSuccess,
  allowedTypes,
}: CreateCredentialDialogProps) {
  return (
    <CredentialDialog
      open={open}
      onOpenChange={onOpenChange}
      allowedTypes={allowedTypes}
      onSuccess={onSuccess}
    />
  );
}
